import React from 'react'
import { Circle, GoogleMap, Marker, Polygon, Polyline, withGoogleMap } from 'react-google-maps'
import * as carMarker from 'src/components/icons/google-map/CarIcon.svg'
import * as dropOffMarker from 'src/components/icons/google-map/DropOffIcon.svg'
import * as pickUpMarker from 'src/components/icons/google-map/PickUpIcon.svg'
import { IMapProps } from 'src/types/rider-portal-map'

const MARKER_ICON = {
  dropOff: dropOffMarker,
  operator: carMarker,
  pickUp: pickUpMarker
}

const RiderPortalMap = withGoogleMap(
  ({
    center,
    isMarkerDraggable,
    markers,
    polyline,
    serviceZones = [],
    handleMarkerDragged,
    onMapMounted
  }: IMapProps) => {
    const CIRCLE_ZONE = serviceZones.filter((zone: { shapeType: string }) => zone.shapeType === 'shape_circle')
    const POLYGON_ZONE = serviceZones.filter((zone: { shapeType: string }) => zone.shapeType === 'shape_multipolygon')

    const plotLocationMarkers = () => {
      return (
        <>
          {!!markers.length &&
            markers.map(({ coordinates, type }, index) => {
              if (coordinates !== null) {
                return (
                  <Marker
                    draggable={isMarkerDraggable}
                    key={`${coordinates.lat}-${coordinates.lng}-${index}`}
                    icon={{ url: MARKER_ICON[type as keyof typeof MARKER_ICON].toString() }}
                    position={coordinates}
                    zIndex={10}
                    onDragEnd={(e: google.maps.MouseEvent) => {
                      if (isMarkerDraggable) {
                        handleMarkerDragged(e, type)
                      }
                    }}
                  />
                )
              } else {
                return null
              }
            })}
        </>
      )
    }

    const parsePolygonPaths = (coordinates: number[][]) => {
      return coordinates.map(coordinate => ({ lat: coordinate[1], lng: coordinate[0] }))
    }

    return (
      <GoogleMap
        defaultCenter={center}
        defaultZoom={15}
        mapTypeId={'roadmap'}
        options={{
          mapTypeControl: false,
          mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite']
          },
          streetViewControl: false
        }}
        ref={onMapMounted}
      >
        {plotLocationMarkers()}
        {!!polyline.length && <Polyline path={polyline} options={{ strokeColor: '#38B44F', zIndex: 10 }} />}

        {!!CIRCLE_ZONE.length &&
          CIRCLE_ZONE.map(({ center: { coordinates }, color, id, radius }) => (
            <Circle
              center={{ lat: coordinates[1], lng: coordinates[0] }}
              key={id}
              options={{
                fillColor: color,
                fillOpacity: 0.2,
                strokeColor: color,
                strokeOpacity: 0.5,
                strokeWeight: 2
              }}
              radius={radius}
            />
          ))}

        {!!POLYGON_ZONE.length &&
          POLYGON_ZONE.map(({ color, id, shape: { coordinates } }) => (
            <Polygon
              key={id}
              options={{
                fillColor: color,
                fillOpacity: 0.2,
                strokeColor: color,
                strokeOpacity: 0.5,
                strokeWeight: 2
              }}
              paths={parsePolygonPaths(coordinates[0][0])}
            />
          ))}
      </GoogleMap>
    )
  }
)

export default RiderPortalMap



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/google/map/Map.tsx